import { NEW_ID } from '@/util/constants';
import { Category } from './category.model';
import { Address } from './info.model';
import { ImpactArea } from './initiative.model';

export enum Repeatability {
  Never = 'never',
  Weekly = 'weekly',
  BiWeekly = 'bi-weekly',
  Monthly = 'monthly',
}

export interface EventItem {
  id: number;
  creationDate: string;
  title: string;
  description: string;
  url: string;
  location: string;
  impactArea: ImpactArea;
  imageUrl: string;
  startDate: string | null; // start date & time also if repeatable
  endDate: string | null; // end date & time also if repeatable, used to calculate duration
  repeats: Repeatability;
  address: Address;
  mainCategory: Category;
  categories: Category[];
  published: boolean;
  dismissed: boolean;
}

export const titleRules = [
  (value: string) => {
    if (value) return true;

    return 'Name is required.';
  },
];

export const descriptionRules = [
  (value: string) => {
    if (value) return true;

    return 'Description is required.';
  },
];

export const repeatOptions = [
  {
    title: 'Never',
    value: Repeatability.Never,
  },
  {
    title: 'Weekly',
    value: Repeatability.Weekly,
  },
  {
    title: 'BiWeekly',
    value: Repeatability.BiWeekly,
  },
  {
    title: 'Monthly',
    value: Repeatability.Monthly,
  },
];

export const defaultEventItem: EventItem = {
  id: NEW_ID,
  title: '',
  url: '',
  description: '',
  published: false,
  dismissed: false,
  creationDate: '',
  imageUrl: '',
  location: '',
  impactArea: ImpactArea.Local,
  startDate: null,
  endDate: null,
  repeats: Repeatability.Never,
  mainCategory: {} as Category,
  categories: [],
  address: {
    street: '',
    house_number: '',
    country: '',
    city: '',
    postal_code: '',
  },
};
